var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteSupplychain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0 0.396)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 20,
    height: 20,
    transform: "translate(0 -0.396)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(1.279 0.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M1726.558,1225.386h-2.014v1.94h-1.3v-1.94h-2.014v4.726h5.327Z",
    transform: "translate(-1716.74 -1217.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1713.688,1196.134l-1.043-.581a.827.827,0,0,1-.431-.72v-1.813a.827.827,0,0,1,.431-.72l1.043-.581a.815.815,0,0,0,.315-1.135l-1.262-2.111a.878.878,0,0,0-1.176-.3l-1.043.581a.887.887,0,0,1-.861,0l-1.626-.906a.827.827,0,0,1-.431-.72v-1.162a.846.846,0,0,0-.861-.831h-2.525a.846.846,0,0,0-.861.831v1.162a.826.826,0,0,1-.431.72l-1.626.906a.888.888,0,0,1-.861,0l-1.043-.581a.878.878,0,0,0-1.176.3l-1.262,2.111a.816.816,0,0,0,.315,1.135l1.042.581a.826.826,0,0,1,.431.72v1.812a.826.826,0,0,1-.431.72l-1.042.581a.816.816,0,0,0-.315,1.136l1.262,2.111a.878.878,0,0,0,1.176.3l1.043-.581a.888.888,0,0,1,.861,0l1.626.906a.826.826,0,0,1,.431.72v1.162a.847.847,0,0,0,.861.831h2.525a.847.847,0,0,0,.861-.831v-1.162a.826.826,0,0,1,.431-.72l1.626-.906a.888.888,0,0,1,.861,0l1.043.581a.878.878,0,0,0,1.176-.3l1.262-2.111A.815.815,0,0,0,1713.688,1196.134Zm-3.462-.521a.307.307,0,0,1-.136.256l-2.963,1.962-.005,0a.309.309,0,0,1-.064.03l-.018.005a.286.286,0,0,1-.076.011h-5.926a.3.3,0,0,1-.3-.305v-5.336s0,0,0-.007,0-.009,0-.014a.322.322,0,0,1,.015-.075s0-.009,0-.013a.3.3,0,0,1,.04-.073l.011-.013a.3.3,0,0,1,.063-.059h0l2.963-1.962a.3.3,0,0,1,.164-.049h5.926c.007,0,.012,0,.019,0a.285.285,0,0,1,.064.011l.031.012a.233.233,0,0,1,.029.011c.008,0,.013.01.02.015a.276.276,0,0,1,.028.021.285.285,0,0,1,.039.041c.006.008.014.016.02.025a.334.334,0,0,1,.031.066s0,.008.006.013v0a.313.313,0,0,1,.012.084Z",
    transform: "translate(-1696.845 -1185.13)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteSupplychain);
export default __webpack_public_path__ + "static/media/white_supplychain.529b5a99ab72e468621d057085841e20.svg";
export { ForwardRef as ReactComponent };